export default {"src":"/_next/static/media/avatarblack.2d7d29f0.svg","height":31,"width":30};